import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import EmptyData from "../../Global/EmptyData";
import CustomDateRangePicker from "../../Global/CustomDateRangePicker";
import useFeedback from "./useFeedback";

const Feedback = () => {
  const {
    date,
    isLoading,
    isFetching,
    feedbackList,
    feedbackState,
    showEditModal,
    paginationOptions,
    handleEditColumnsClick,
    handleDateRangeChange,
    updateFeedbackFields,
    handleDateChange,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useFeedback();
  return (
    <>
      <HeadingGroup title="Feedback" className={`pro-mb-4`} />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={feedbackState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: feedbackState?.search }}
          handleActionClick={handleEditColumnsClick}
          searchable={false}
          dropDownFilter={
            <>
              <div className="col-auto">
                <CustomDateRangePicker
                  defaultDateRange={date}
                  handleDateRangeChange={handleDateRangeChange}
                />
              </div>
            </>
          }
          onDateChange={handleDateChange}
          initialDateRange={date}
        />
        {feedbackList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={feedbackList?.data?.result || []}
            uniqueID={"id"}
            fields={feedbackList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={feedbackState?.clearSelection}
            perpage={feedbackState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}

        {feedbackList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={feedbackState?.currentPage}
            totalPageCount={Math.ceil(
              feedbackList?.data.total_count / feedbackState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === feedbackState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={feedbackList?.data?.fields || []}
              moduleId={feedbackList?.data?.module_id}
              updateData={updateFeedbackFields}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default Feedback;
